var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXplaLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 26,
    fill: "none",
    viewBox: "0 0 83 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.528 8.228h-2.461l-4.02 3.43-3.991-3.43h-2.584l5.304 4.507-5.66 4.76h2.393l4.402-3.71 4.375 3.71h2.625l-5.701-4.816 5.318-4.451Zm8.352 0h-7.245v1.568h6.726c2.037 0 2.994.518 2.994 1.638 0 1.385-1.86 1.595-2.98 1.595h-6.713v4.452h1.818v-2.912h5.4c2.68 0 4.293-1.176 4.293-3.136 0-1.96-1.64-3.233-4.292-3.233v.028Zm7.384 0h-1.819v9.267h9.953V15.94h-8.134V8.228Zm13.644 9.267h9.351l-6.043-8.763c-.273-.406-.656-.616-1.107-.616-.451 0-.847.224-1.107.616l-6.139 8.763h2.174l5.045-7.28 3.896 5.712h-6.056v1.568h-.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B1FF",
    d: "M12.166 25.124c6.644 0 12.03-5.515 12.03-12.319 0-6.803-5.386-12.318-12.03-12.318C5.52.487.135 6.002.135 12.805c0 6.804 5.386 12.319 12.03 12.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.894 13.682-.851.871 5.849 5.989.85-.871-5.848-5.989ZM5.44 5.055l-.85.871 5.848 5.989.851-.871-5.848-5.989Zm13.44.01-5.844 5.993.851.87 5.845-5.993-.851-.87Zm-8.426 8.631-5.845 5.993.852.87 5.844-5.993-.851-.87Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h82.124v24.637H0z",
    transform: "translate(.135 .487)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXplaLogoWhite);
export default __webpack_public_path__ + "static/media/xplaLogo-white.1660e5d5b9c6121af2136bc2111772fd.svg";
export { ForwardRef as ReactComponent };